{
    "title": "Welcome back!",
    "featureSectionTitle": "Here's what's new:",
    "features": [
        {
            "url": "https://www.nutshell.com/blog/improve-chat-conversions-with-engagement-report",
            "text": "All-in-one AI Chatbot / Engagement bar report"
        },
        {
            "url": "https://www.nutshell.com/blog/voice-to-text-activity-logging",
            "text": "AI-powered mobile activity logging"
        },
        {
            "url": "https://www.nutshell.com/blog/catch-engaged-leads-early-with-page-based-marketing-automations",
            "text": "Page-based marketing automations"
        },
        {
            "url": "https://www.nutshell.com/blog/launch-campaigns-even-faster-with-the-nutshell-1-click-ai-email-generator",
            "text": "1-click AI email campaign generator"
        }
    ],
    "readMore": {
        "fullText": "🌸 Read more about our spring updates",
        "linkText": "Read more",
        "url": "https://www.nutshell.com/product-updates"
    }
}
